export const FORM_LOAD = 'form_load';
export const FORM_COMPLETE = 'form_complete';

export const REQUIRED_TEXT = '(required)';

export const CONFIRMATION_FIELD = 'Confirm';
